/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */


import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import * as models from '../model/models';
import { Requester } from '../requester';
import { PagedArray } from '../paged-array';

/* tslint:disable:no-unused-variable member-ordering */


@Injectable()
export class TalentApi {
    constructor(
        protected requester: Requester
    ) {
    }

    /**
     * get articles feed of the talent
     * @param id 
     * @param offset 
     * @param limit 
     */
    public getTalentArticles(id?: string, offset?: number, limit?: number, __unused?: any): Observable<PagedArray<models.ApiArticle>> {
        const path = '/content/talent/{id}/articles'
                    .replace('{' + 'id' + '}', String(id));

        let queryParameters : Record<string,string> = {};
        let headers : Record<string,string> = {}; 
        if (offset !== undefined) {
            queryParameters['offset'] = <any>offset;
        }

        if (limit !== undefined) {
            queryParameters['limit'] = <any>limit;
        }


        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;

        return this.requester
            .request<PagedArray<models.ApiArticle>>(
                requestMethodStr, 
                requestPath, 
                queryParameters,
                headers,
            );
    }

    /**
     * Get a specific talent
     * @param id 
     */
    public get(id?: string, __unused?: any): Observable<models.ApiTalent> {
        const path = '/content/talent/{id}'
                    .replace('{' + 'id' + '}', String(id));

        let queryParameters : Record<string,string> = {};
        let headers : Record<string,string> = {}; 

        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;

        return this.requester
            .request<models.ApiTalent>(
                requestMethodStr, 
                requestPath, 
                queryParameters,
                headers,
            );
    }

    /**
     * Get the list of all hosts&#x2F;talent at TYT
     * @param q 
     * @param count 
     */
    public all(q?: string, count?: number, __unused?: any): Observable<PagedArray<models.ApiTalent>> {
        const path = '/content/talent';

        let queryParameters : Record<string,string> = {};
        let headers : Record<string,string> = {}; 
        if (q !== undefined) {
            queryParameters['q'] = <any>q;
        }

        if (count !== undefined) {
            queryParameters['count'] = <any>count;
        }


        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;

        return this.requester
            .request<PagedArray<models.ApiTalent>>(
                requestMethodStr, 
                requestPath, 
                queryParameters,
                headers,
            );
    }

}
